var _style, _circle, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSa(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#6DA544;}\n\t.st1{fill:#F0F0F0;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 256,
    cy: 256,
    r: 256
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M144.7,306.1c0,18.4,14.9,33.4,33.4,33.4h100.2c0,15.4,12.5,27.8,27.8,27.8h33.4c15.4,0,27.8-12.5,27.8-27.8 v-33.4H144.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M370.1,144.7v77.9c0,12.3-10,22.3-22.3,22.3v33.4c30.7,0,55.7-25,55.7-55.7v-77.9L370.1,144.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M130.8,222.6c0,12.3-10,22.3-22.3,22.3v33.4c30.7,0,55.7-25,55.7-55.7v-77.9h-33.4L130.8,222.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M320,144.7h33.4v77.9H320V144.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M269.9,189.2c0,3.1-2.5,5.6-5.6,5.6s-5.6-2.5-5.6-5.6v-44.5h-33.4v44.5c0,3.1-2.5,5.6-5.6,5.6 s-5.6-2.5-5.6-5.6v-44.5h-33.4v44.5c0,21.5,17.5,39,39,39c8.3,0,15.9-2.6,22.3-7c6.3,4.4,14,7,22.3,7c1.7,0,3.3-0.1,4.9-0.3 c-2.4,9.7-11.1,17-21.6,17v33.4c30.7,0,55.7-25,55.7-55.7v-33.4v-44.5h-33.4L269.9,189.2L269.9,189.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M180.9,244.9H231v33.4h-50.1V244.9z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSa);
export default __webpack_public_path__ + "static/media/sa.41627c094f5d4f724ed837dc7aacf70d.svg";
export { ForwardRef as ReactComponent };